import { saveFile } from "../native/files";

export const downloadOffer = async (offerId, setLoading) => {
    if (setLoading) setLoading(true);

    try {
        const token = localStorage.getItem("token");
        const url = `${process.env.REACT_APP_BACKEND_URL}/quotations/download/${offerId}`;

        const response = await fetch(url, {
            headers: { Authorization: "Bearer " + token }
        });

        if (!response.ok) throw new Error("Failed to generate PDF");

        const blob = await response.blob();

        const base64String = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(",")[1]);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: "DOWNLOAD_PDF",
                data: base64String,
                filename: `Angebot-${offerId}.pdf`
            }));
        } else {
            const pdfBlob = new Blob([blob], { type: "application/pdf" });
            await saveFile(pdfBlob, `Angebot-${offerId}.pdf`);
        }

    } catch (error) {
        console.error("Error downloading PDF:", error);
        throw error;
    } finally {
        if (setLoading) setLoading(false);
    }
};
